import { styled } from '@mui/material/styles';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids/DatagridConfigurableWithStickyActions/DatagridConfigurableWithStickyActions';
import { withDatagridStickyStyles } from 'shared/react-admin/Datagrids/DatagridSticky/withDatagridStickyStyles';
import { getColumnStyle } from 'utils/getColumnStyle';

const StickyDatagridConfigurableWithStickyActions = withDatagridStickyStyles(
  DatagridConfigurableWithStickyActions,
);

export const DatagridStyled = styled(StickyDatagridConfigurableWithStickyActions)({
  '& .column-ladderType:has(.MuiBox-root)': getColumnStyle(280),
  '&:not(:has(.column-ladderType .MuiBox-root)) td.column-name > .MuiTypography-root': {
    display: 'block',
    width: 'max-content',
    maxWidth: '440px',
  },
  '& .column-rate': {
    minWidth: '160px',
  },
});
